import React from 'react';
import {
    AdCampaigns,
    Alerts,
    Appointments,
    Auth,
    Charts,
    Documents,
    DPXConversations,
    FinancialInstitutions,
    Group,
    StoreGroup,
    Investments,
    Leads,
    Mails,
    ServiceClientState,
    ContactState,
    WarboxConversationState,
    WarboxMessageState,
    MailsDocumentation,
    MaintenancePackageState,
    Makes,
    Medias,
    Notifications,
    Recordings,
    RecordingTests,
    Sales,
    Settings,
    Sources,
    Statuses,
    Stores,
    Substatuses,
    Tasks,
    TemplatesTwilio,
    Tickets,
    Users,
    Vehicles,
    Visits,
    EvaluationState,
    MetaState,
} from 'src/contexts';

export const WarboxProvider = ({ children }) => {
    return (
        <AdCampaigns>
            <Alerts>
                <Appointments>
                    <Auth>
                        <Charts>
                            <Documents>
                                <DPXConversations>
                                    <FinancialInstitutions>
                                        <Group>
                                            <Investments>
                                                <Leads>
                                                    <StoreGroup>
                                                        <ServiceClientState>
                                                            <MaintenancePackageState>
                                                                <Mails>
                                                                    <MailsDocumentation>
                                                                        <Makes>
                                                                            <Medias>
                                                                                <Notifications>
                                                                                    <Recordings>
                                                                                        <RecordingTests>
                                                                                            <ContactState>
                                                                                                <Sales>
                                                                                                    <Settings>
                                                                                                        <Sources>
                                                                                                            <Statuses>
                                                                                                                <Stores>
                                                                                                                    <Substatuses>
                                                                                                                        <Tasks>
                                                                                                                            <TemplatesTwilio>
                                                                                                                                <Tickets>
                                                                                                                                    <Users>
                                                                                                                                        <Vehicles>
                                                                                                                                            <Visits>
                                                                                                                                                <EvaluationState>
                                                                                                                                                    <MetaState>
                                                                                                                                                        <ContactState>
                                                                                                                                                            <WarboxConversationState>
                                                                                                                                                                <WarboxMessageState>
                                                                                                                                                                    {
                                                                                                                                                                        children
                                                                                                                                                                    }
                                                                                                                                                                </WarboxMessageState>
                                                                                                                                                            </WarboxConversationState>
                                                                                                                                                        </ContactState>
                                                                                                                                                    </MetaState>
                                                                                                                                                </EvaluationState>
                                                                                                                                            </Visits>
                                                                                                                                        </Vehicles>
                                                                                                                                    </Users>
                                                                                                                                </Tickets>
                                                                                                                            </TemplatesTwilio>
                                                                                                                        </Tasks>
                                                                                                                    </Substatuses>
                                                                                                                </Stores>
                                                                                                            </Statuses>
                                                                                                        </Sources>
                                                                                                    </Settings>
                                                                                                </Sales>
                                                                                            </ContactState>
                                                                                        </RecordingTests>
                                                                                    </Recordings>
                                                                                </Notifications>
                                                                            </Medias>
                                                                        </Makes>
                                                                    </MailsDocumentation>
                                                                </Mails>
                                                            </MaintenancePackageState>
                                                        </ServiceClientState>
                                                    </StoreGroup>
                                                </Leads>
                                            </Investments>
                                        </Group>
                                    </FinancialInstitutions>
                                </DPXConversations>
                            </Documents>
                        </Charts>
                    </Auth>
                </Appointments>
            </Alerts>
        </AdCampaigns>
    );
};
